


import React from 'react';
import { Outlet } from 'react-router-dom';
import AuthHeader from '../components/Headers/AuthHeader';
import { Box,} from '@mui/material';
import useHealthCheck from "../pages/Hooks/HealthCheck"
const AuthLayout = () => {
    // useHealthCheck(); 
  return(
  <>
<Box sx={{}}>
    <AuthHeader />
    <main style={{ padding: '0px',margin:"0px" }}>
      <Outlet />
    </main>
    </Box>
  </>
  )
}

export default AuthLayout;